import React, { useState } from "react";
import axios from "axios";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const res = await axios.post(
        "https://panafricanbookexchange-wandererspath.com/api/auth/forgot-author-password",
        { email }
      );
      setMessage(res.data.message);
    } catch (error) {
      setMessage(
        error.response?.data?.error || "Failed to send reset link. Please check your network connection."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-inner">
      <h2>Forgot Password</h2>

      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit" disabled={loading} className="btn btn-primary">
          {loading ? "Sending..." : "Send Reset Link"}
        </button>
      </form>

      {message && <p className="alert-info mt-2">{message}</p>}
    </div>
  );
}